import React from "react";
import PropTypes from "prop-types";
import MessageRcs from "../rcs/Message";
import MessageText from "../rcs/MessageText";
import { MessageChat } from "../rcs/DevicePreview";
import { useFormikContext } from "formik";
import _Select from "../../../components/generic/_Select";
import { Tooltip } from "../../../components/ui/Tooltip";
const MessageSimpleRcs = ({ step, isAdmin = false }) => {
  const { values, handleChange, handleBlur, errors } = useFormikContext();

  const { ttl } = values;
  return (
    <div className="bg-white py-3 rounded-lg">
      <div className="px-4">
        <div className="flex justify-between items-center">
          <div className="flex items-end gap-2 my-2">
            <div className="flex items-center justify-center size-8 rounded-full bg-[#009CFF] text-white">
              <span className="font-bold">{step}</span>
            </div>
          </div>
        </div>
        <div className="w-full py-2 border rounded-lg px-2 my-1">
          <div className="flex justify-between">
            <span className="text-[14px] font-semibold flex justify-center gap-2 items-center text-gray-600 rounded-lg">
              Tiempo de Vida del Mensaje (TTL)
            </span>
            <Tooltip message="El TTL es el tiempo de vida del mensaje en donde se considerará válido y entregable. Si el mensaje no se entrega correctamente al dispositivo del usuario dentro de este período, se intenta revocarlo automáticamente">
              <span className="material-icons-outlined cursor-pointer">
                info
              </span>
            </Tooltip>
          </div>
          <_Select
            name="ttl"
            id="ttl"
            value={ttl}
            onChange={handleChange}
            onBlur={handleBlur}
            errors={errors && errors.ttl}
            isError={errors && errors.ttl ? true : false}
            options={[
              {
                vale: "60s",
                label: "Predeterminado (1 minuto)",
              },
              {
                value: "600s",
                label: "10 minutos",
              },
              {
                value: "3600s",
                label: "1 hora",
              },
              {
                value: "86400s",
                label: "24 horas",
              },
              {
                value: "1296000s",
                label: "Máximo (15 días)",
              },
            ]}
          />
        </div>
        <div className="border rounded-lg">
          <div className="grid grid-cols-12">
            <div className="col-span-8">
              <MessageRcs isAdmin={isAdmin} />
            </div>
            <div className="col-span-4">
              <div className="text-md font-semibold py-3 mx-1">
                Previsualización
              </div>
              <MessageChat />
            </div>
          </div>
        </div>

        <div className="border rounded-lg mt-2">
          <MessageText />
        </div>
      </div>
    </div>
  );
};

MessageSimpleRcs.propTypes = {
  step: PropTypes.number,
  isAdmin: PropTypes.bool,
};

export default MessageSimpleRcs;
